export default __webpack_public_path__ + "static/ioi-8a61d5e6bbec4bfd53192a86fbd5469b.jpg";